module.exports = {"API_BASE_URL":"https://api.defidirect.com/api/","IMG_BASE_URL":"./V2/assets/img/","Text_color":"#969798"}


//////////////////
// WEBPACK FOOTER
// ./src/client/resources/config.json
// module id = 57
// module chunks = 0